import { Marker, Popup } from 'react-leaflet';
import { createLeafletIconFromImage } from '../../utils/mapIcons';
import iconMap from '../../utils/mapIcons';
import { serviceType, serviceTypeDetails } from '../../enum/serviceType';
import StopPopup from '../stop/StopPopup';
import { useAppState } from '../../context/AppStateProvider';

function BUSStopMarkers({ stops, userLocation, onStopSelect }) {
  const busService = serviceTypeDetails.find(s => s.type === serviceType.BUS);
  const icon = createLeafletIconFromImage(iconMap.BUS, busService.color);
  const { setSelectedStop } = useAppState();
  return (
    <>
      {stops.map((stop) => {
        const stopLat = parseFloat(stop.stop_lat);
        const stopLon = parseFloat(stop.stop_lon);

        return (
          <Marker key={stop.stop_id} position={[stopLat, stopLon]} icon={icon}
          >
            <Popup
              eventHandlers={{
                remove: () => setSelectedStop(null),
              }}
            >
              <StopPopup stop={stop} userLocation={userLocation} showMore={true} />
            </Popup>
          </Marker>
        );
      })}
    </>
  );
}

export default BUSStopMarkers;
